<template>
  <div class="productFilter">
    <div id="prdfilter">
      <h4>
        {{titulo_interno}}
      </h4>
      <p class="d-flex mb-3">
        <span class="filter-labels">Utiliza los filtros de busqueda para encontrar tu producto:</span>
      </p>
       
      <div class="form-group createProduct" v-if="loggedUser && loggedUser.isAdmin">
        <button class="btn buttonGreen-outline" @click="openCreateModal">Create New Product</button>
      </div>

       <div class="form-group">
          <label for="filterPrdCty" class="filter-labels">Filtrar por categoría:</label>
          <select class="form-control" id="filterPrdCty" v-model="id_categoria" @change="(event) => cboCateAction()">
            <option value="0">Todas las categorias</option>
            <option v-for="(category, index) in categories" :key="index" v-bind:value="category.id_category">{{category.product_type_desc_es}}</option>
          </select>
        </div>
     

     
       <div class="form-group">
          <label for="filterPrdCty" class="filter-labels">Filtrar por subcategoria:</label>
          <select class="form-control" id="filterPrdCty" v-model="id_subcategoria" :disabled="isdisabledCate" @change="(event) => cboSubCateAction()">
            <option value="0">Todas las subcategorias</option>
            <option selected="selected" v-for="(subcategory, index) in subcategories" :key="index" v-bind:value="subcategory.id_category">{{subcategory.product_type_desc_es}}</option>
          </select>
        </div>
     
      <div v-if="useQuery==0 && calibers.length!=0" class="form-group">
          <label for="filterPrdCty" class="filter-labels">Filtrar por calibre:</label>
          <select class="form-control" id="filterPrdCty" v-model="id_caliber" :disabled="isdisabledSubCate" @change="(event) => cboCaliberAction()">
            <option value="0" selected>Todos los calibres</option>
            <option selected="selected" v-for="(caliber, index) in calibers" :key="index" v-bind:value="caliber.desc_caliber">{{caliber.desc_caliber}}</option>
          </select>
        </div>

      <div v-if="useQuery==0" class="form-group">
          <label for="filterPrdCty" class="filter-labels">Filtrar por marcas:</label>
          <select class="form-control" id="filterPrdCty" v-model="id_brand" :disabled="isdisabledSubCate"  @change="(event) => cboBrandAction()">
            <option value="0" selected>Todas las marcas</option>
            <option selected="selected" v-for="(brand, index) in brands" :key="index" v-bind:value="brand.brand_code">{{brand.desc_brand}}</option>
          </select>
        </div>

      <div class="form-group">
        <label for="filterPrdSlr" class="filter-labels">Ordenar productos por:</label>
        <select class="form-control" id="filterPrdSlr" v-model="id_criterio" @change="(event) => cboCritAction()">
          <option value='0' selected>Mas vendidos</option>
          <option value='1'>Precios mas bajos primero</option>
          <option value='2'>Precios mas altos primero</option>
          <option value='3'>A - Z</option>
          <option value='4'>Z - A</option>
          <option value='5'>Calibre (ASC)</option>
          <option value='6'>Calibre (DESC)</option>
        </select>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "productFilter",
  props: ["categories", "subcategories", "titulo_interno", "subcate", "cate", "caliber", "brand", "crit", "query", "brands", "calibers"],
  computed: mapState(["loggedUser"]),
  data() {
    return {
      isdisabledCate: true,
      isdisabledSubCate: true,
      id_categoria: '0',
      id_subcategoria: '0',
      id_criterio: '0',
      id_brand: '0',
      id_caliber: '0',
      useQuery: '0',
      showCreateProductModal: false
    };
  },
  methods: {
    
    openCreateModal() {
      this.$refs.createProduct.showModalForm();
    },

    cboCateAction(){
      this.$router.push("/productos/"+this.id_criterio+"/1/"+this.id_categoria+"/0/0/0/"+this.useQuery);
    },

    cboSubCateAction(){
      this.$router.push("/productos/"+this.id_criterio+"/1/"+this.id_categoria+"/"+this.id_subcategoria+"/0/0/"+this.useQuery);
    },

    cboCaliberAction(){
      this.updateUrl();  
    },

    cboBrandAction(){
      this.updateUrl();
    },

    cboCritAction(){
      this.updateUrl();
    },

    updateUrl(){
      this.$router.push("/productos/"+this.id_criterio+"/1/"+this.id_categoria+"/"+this.id_subcategoria+"/"+this.id_caliber+"/"+this.id_brand+"/"+this.useQuery);
    }
 
  },

  created() {
    
    this.id_criterio = this.crit;
    this.useQuery = this.query;

    if(this.cate!=0){

      this.id_categoria = this.cate;
      this.$parent.listar_subcategorias(this.id_categoria);
      this.isdisabledCate = false;

      if(this.subcate==0 || this.subcate=='0'){
        this.$parent.listar_marcasxcate(this.id_categoria);
        this.$parent.listar_calibresxcate(this.id_categoria);
        this.$parent.detalleCategoria(this.id_categoria);
        this.isdisabledSubCate = true;
      }
      else {
        this.id_subcategoria = this.subcate;
        this.$parent.listar_marcasxsubcate(this.id_subcategoria);
        this.$parent.listar_calibresxsubcate(this.id_subcategoria);
        this.$parent.detalleSubCategoria(this.id_subcategoria);
        this.isdisabledSubCate = false;
      }
      
      this.id_caliber = this.caliber;
      this.id_brand = this.brand;
      
      
     }
      
  }
  
}
</script>

<style lang="scss">
.productFilter {
  #prdfilter {
    text-align: start !important;
  }
}

.filter-labels{
  font-size: 14px;
}
</style>